export default __webpack_public_path__ + "static/university-of-helsinki-e364abe65d8b13ffeff627966cbfaa9e.png";